import type { SchemaChatResolver_GetChats } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';
import { LuTriangleAlert } from 'react-icons/lu';

import { ChatNumberSwitchButton } from './ChatNumberSwitchButton';
import { CHAT_NUMBER_STATUSES } from '~/features/whatsapp/constants/chatNumberStatus';
import { useOwnDivisionPhoneNumberId } from '~/features/whatsapp/hooks/useOwnDivisionPhoneNumberId';
import { resolveChatNumberStatus } from '~/features/whatsapp/utils/resolveChatNumberStatus';
import { cn } from '~/utils/cnTailwind';

type Props = {
    chat: SchemaChatResolver_GetChats[number];
    senderUnavailable: boolean;
};

export const ChatNumberBanner = ({ chat, senderUnavailable }: Props) => {
    const { t } = useTranslation();
    const ownPhoneNumberId = useOwnDivisionPhoneNumberId();
    const status = resolveChatNumberStatus({
        chatPhoneNumberId: chat.phoneNumberId,
        ownPhoneNumberId,
        senderUnavailable,
    });

    if (status !== CHAT_NUMBER_STATUSES.FOREIGN && status !== CHAT_NUMBER_STATUSES.UNAVAILABLE) return null;

    const isUnavailable = status === CHAT_NUMBER_STATUSES.UNAVAILABLE;

    return (
        <div
            className={cn(
                'flex items-center gap-2 px-4 py-2 text-xs',
                isUnavailable ? 'bg-status-red-bg text-status-red-text' : 'bg-status-yellow-bg text-status-yellow-text',
            )}
        >
            <LuTriangleAlert className="shrink-0" />
            <span className="min-w-0 flex-1">
                {isUnavailable
                    ? t('WHATSAPP_CHAT.NUMBER_STATUS.UNAVAILABLE')
                    : t('WHATSAPP_CHAT.NUMBER_STATUS.FOREIGN')}
            </span>
            <ChatNumberSwitchButton chat={chat} />
        </div>
    );
};
